export const montarCubeQueryPadrao = ({
  medida = 'DataBlendingVisao.sumValorTotal',
  centrosSelecionados = [],
  objetosSelecionados = [],
  dataInicio,
  dataFim,
  periodo,
  indicadorSelecionado
}) => {
  const filters = [];
  const dimensions = [];
  const timeDimensions = [];

  if (centrosSelecionados.length > 0) {
    dimensions.push('CentroCusto.descricao');
    filters.push({
      member: 'CentroCusto.id',
      operator: 'equals',
      values: centrosSelecionados.map(c => String(c.id))
    });
  }

  if (objetosSelecionados.length > 0) {
    dimensions.push('ObjetoCusto.descricao');
    filters.push({
      member: 'ObjetoCusto.id',
      operator: 'equals',
      values: objetosSelecionados.map(o => String(o.id))
    });
  }

  if (dataInicio && dataFim) {
    filters.push({
      member: 'DataBlendingVisao.data',
      operator: 'inDateRange',
      values: [dataInicio, dataFim]
    });
  }

  if (medida) {
    filters.push({
      member: medida,
      operator: 'set'
    });
  }

  if (medida === 'DataBlendingVisao.CustoPorDivisor') {
    filters.push({
      or: [
        {
          member: 'DataBlendingVisao.idDivisor',
          operator: 'equals',
          values: [String(indicadorSelecionado?.id || '')]
        },
        {
          member: 'DataBlendingVisao.idDivisor',
          operator: 'equals',
          values: ['0']
        }
      ]
    });
  }

  if (periodo && periodo !== 'Nenhum') {
    timeDimensions.push({
      dimension: 'DataBlendingVisao.data',
      granularity: periodo
    });
  }

  return {
    measures: [medida],
    dimensions,
    filters,
    timeDimensions
  };
};

export const montarCubeQueryDrilldown = ({
  idsCentroCustoDetalhados,
  idsObjetoCustoDetalhados,
  dataInicio,
  dataFim,
  medida,
  idSuperior = null,
  divisorSelecionado
}) => {
  const filters = [];

  if (idsCentroCustoDetalhados?.length > 0) {
    filters.push({
      member: 'CentroCustoDrilldown.idInferior',
      operator: 'equals',
      values: idsCentroCustoDetalhados.map(id => id.toString())
    });
  }

  if (idsObjetoCustoDetalhados?.length > 0) {
    filters.push({
      member: 'ObjetoCusto.id',
      operator: 'equals',
      values: idsObjetoCustoDetalhados.map(id => id.toString())
    });
  }

  if (dataInicio && dataFim) {
    filters.push({
      member: 'DataBlendingVisao.data',
      operator: 'inDateRange',
      values: [dataInicio, dataFim]
    });
  }

  if (medida) {
    filters.push({ member: medida, operator: 'set' });
  }

  if (medida === 'DataBlendingVisao.CustoPorDivisor') {
    filters.push({
      or: [
        {
          member: 'DataBlendingVisao.idDivisor',
          operator: 'equals',
          values: [divisorSelecionado?.toString() || null]
        },
        {
          member: 'DataBlendingVisao.idDivisor',
          operator: 'equals',
          values: ['0']
        }
      ]
    });
  }

  filters.push({
    member: 'CentroCustoDrilldown.idSuperior',
    operator: 'equals',
    values: [idSuperior]
  });

  return {
    measures: [
      'DataBlendingVisao.CustoPorDivisor',
      'DataBlendingVisao.CustoPorDivisorByTotal',
      'DataBlendingVisao.sumValorTotal',
      'DataBlendingVisao.avgValorDivisor',
      'DataBlendingVisao.TotalDivisor'
    ],
    dimensions: [
      'CentroCustoDrilldown.descricao',
      'ObjetoCusto.descricao',
      'CentroCustoDrilldown.id',
      'CentroCustoDrilldown.hasChilds',
      'CentroCustoDrilldown.idSuperior'
    ],
    filters,
    timeDimensions: []
  };
};
